<template>
  <div style="flex-flow:column; position:relative">
    <el-input
      :placeholder="'キーワード検索（スペース区切りで複数可）'"
      class="side-search-form-input"
      :class="dark_mode ? 'dark' : ''"
      :value="keyword"
      @focus="focus()"
      @input="suggestKeyword($event)"
      @blur="suggest_on ? '' : (suggest_show = false) & (suggest_hover = -1)"
      @keydown.up.native="suggestHover('up')"
      @keydown.down.native="suggestHover('down')"
      @keydown.enter.native="suggestEnter()"
      clearable
      size="mini"
    ></el-input>
    <p style="color: #fff; margin: 2px 0 10px;">のいずれも含む</p>    
    <el-input
      :placeholder="'除外キーワード（スペース区切りで複数可）'"
      class="side-search-form-input"
      :class="dark_mode ? 'dark' : ''"
      v-model="excludeValue"
      @input="updateExcludeKeyword($event)"
      clearable
      size="mini"
    ></el-input>
    <p style="color: #fff; margin: 2px 0 10px;">のいずれも含まない</p>    
    <div class="request-pr-form-suggest sidemenu" id="keyword-box" v-if="suggest_show && keyword != ''" :class="[suggest_keyword.length > 7 ? 'scroll' : '', dark_mode ? 'dark' : '']">
      <div
        class="request-pr-form-suggest-box"
        v-for="(suggest, index) in suggest_keyword"
        :key="suggest.id"
        v-show="keyword != '' || suggest_loading"
        :class="[suggest_hover == index ? 'hover' : '', dark_mode ? 'dark' : '']"
        @click="suggestClick(index)"
        @mouseover="suggest_on = true"
        @mouseleave="suggest_on = false"
      >
        <div :style="dark_mode ? 'color:#fff' : ''">
          <span v-html="$options.filters.bold(suggest.search_keyword, keyword)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const suggestKeywordAPI = root + "/api/search/suggest_keyword";

export default {
  name: "SidemenuSuggestKeyword",
  props: ["sns_type", "keyword", "exclude_keyword"],
  components: {},
  data() {
    return {
      influencer_index: "",
      suggest_keyword: [],
      suggest_loading: false,
      suggest_show: false,
      suggest_hover: -1,
      suggest_on: false,
      requestId: +new Date(),
      excludeValue: ""
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
  },
  created() {},
  mounted() {},
  methods: {
    focus() {
      this.suggest_show = true;
      this.suggestKeyword(this.keyword);
    },
    suggestKeyword(value) {
      this.$emit("update:keyword", value);
      if (value != "") {
        this.suggest_loading = true;
        this.suggest_show = true;
        this.suggest_hover = -1;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(suggestKeywordAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              sns_type: this.sns_type,
              keyword: value,
            },
          })
          .then((response) => {
            this.suggest_keyword = response.data.suggest_keyword;
            this.suggest_loading = false;
          });
      } else {
        this.suggest_keyword = [];
      }
    },
    suggestHover(type) {
      if (type == "up") {
        if (this.suggest_hover == -1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover -= 1;
        }
      } else if (type == "down") {
        if (this.suggest_hover == this.suggest_keyword.length - 1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover += 1;
        }
      }
      var suggest_position = 34;
      var target = document.getElementById("keyword-box");
      if (target) target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    suggestClick(index) {
      this.$emit("update:keyword", this.suggest_keyword[index].search_keyword);
      this.suggest_show = false;
      this.$emit("search");
    },
    suggestEnter() {
      if (this.suggest_hover >= 0) {
        this.$emit("update:keyword", this.suggest_keyword[this.suggest_hover].search_keyword);
        this.$emit("search");
      }
      this.suggest_show = false;
    },
    updateExcludeKeyword(value) {
      this.$emit("update:exclude_keyword", value);
    }
  },
  watch: {
    keyword() {
      this.$emit("resultCount");
    },
    exclude_keyword(value) {
      this.excludeValue = value;
      this.$emit("resultCount");
    },    
  },
  filters: {
    bold(value, keyword) {
      if (keyword) {
        const keyword_RegExp = new RegExp(keyword, "ig");
        return value.replace(keyword_RegExp, (keyword) => '<span class="suggest-highlight">' + keyword + "</span>");
      }
      return value;
    },
  },
};
</script>
